import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";
import { lorem_ipsum } from "./utils";

// @ts-ignore
export const motion_connectors: Record<Partial<RestCallsKey>, MockRestCall> = {
  "info-in-motion.ask-for-connector": {
    delay: 1000,
    payload: async () => true,
  },
  "info-in-motion.connectors-status": {
    delay: 1000,
    payload: async () => {
      const lorem_20 = lorem_ipsum(20);
      return [
        {
          id: "exchange_365",
          name: "Exchange 365",
          desc: lorem_20,
          icon: "Exchange",
          is_on: true,
        },
        {
          id: "sharepoint",
          name: "Sharepoint",
          desc: lorem_20,
          icon: "SharePoint",
          is_on: true,
        },
        {
          id: "ms_teams",
          name: "Teams",
          desc: lorem_20,
          icon: "Teams",
          is_on: true,
        },
        {
          id: "onedrive",
          name: "OneDrive",
          desc: lorem_20,
          icon: "OneDrive",
          is_on: true,
        },
        {
          id: "gmail",
          name: "Gmail",
          desc: lorem_20,
          icon: "GmailColor",
          is_on: false,
        },
        {
          id: "gdrive",
          name: "Google Drive",
          desc: lorem_20,
          icon: "Gdrive",
          is_on: false,
        },
        {
          id: "slack",
          name: "Slack",
          desc: lorem_20,
          icon: "Slack",
          is_on: false,
        },
      ];
    },
  },
};
